module.exports = __webpack_public_path__ + "img/NR.cf852208.png";